import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import InputMask from "react-input-mask";
import { handleUnauthorized } from "../../../src/utils/apiHelper";
import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import Loader from "./../child/Loder";
import { uploadToS3 } from "../../utils/s3Uploader";

const EditSubadminPageNew = () => {
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );
  const [adminRole, setAdminRole] = useState("");
  const [Name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [imagechange, SetImagechnage] = useState(0);
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const [Modulename, setModuleData] = useState([]);
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
  const [AdminData, setAdminData] = useState([]);
  const [uploading, setUploading] = useState(false); // loader for image upload

  const { id } = useParams();
  const isEditMode = !!id;

  const navigate = useNavigate();

  const handleCheckboxChange = (id, permission) => {
    setSelectedPermissions((prevPermissions) => {
      const updatedPermissions = { ...prevPermissions };

      // Ensure the module exists in updatedPermissions
      if (!updatedPermissions[id]) {
        updatedPermissions[id] = {
          selected: false,
          add: false,
          edit: false,
          view: false,
          delete: false,
          review: false,
        };
      }

      if (permission === "selected") {
        // Toggle all permissions when module checkbox is clicked
        const newCheckedState = !updatedPermissions[id].selected;
        updatedPermissions[id] = {
          selected: newCheckedState,
          add: newCheckedState,
          edit: newCheckedState,
          view: newCheckedState,
          delete: newCheckedState,
          review: newCheckedState,
        };
      } else {
        // Toggle the individual permission
        updatedPermissions[id][permission] =
          !updatedPermissions[id][permission];

        // Ensure "selected" is checked if any sub-permission is selected
        updatedPermissions[id].selected =
          updatedPermissions[id].add ||
          updatedPermissions[id].edit ||
          updatedPermissions[id].view ||
          updatedPermissions[id].delete ||
          updatedPermissions[id].review;
      }

      return updatedPermissions;
    });
  };

  useEffect(() => {
    const fetchModuleData = async () => {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/moduleList`;
      try {
        setLoading(true);
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch modules");
        }

        const data = await response.json();

        setModuleData(data.modules || []);
      } catch (err) {
        setErrorMessage(err.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchModuleData();
  }, []);

  useEffect(() => {
    if (!id) return; // Ensure id is defined before making the request

    const fetchAdminData = async () => {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/adminById/${id}`;
      try {
        setLoading(true);
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch admin data");
        }

        const data = await response.json();
        setAdminRole(data?.result?.role || "");
        setName(data.result.name || "");
        setEmail(data.result.email || "");

        setImagePreview(data.result.profilePicture || "");
        setPhone((data.result.dialCode || "") + (data.result.phone || ""));

        // Ensure permissions are formatted correctly
        if (data.result.permissions) {
          const formattedPermissions = {};
          data.result.permissions.forEach((permission) => {
            formattedPermissions[permission.module] = {
              selected:
                permission.add ||
                permission.edit ||
                permission.view ||
                permission.delete ||
                permission.review,
              // Auto-select if any permission is true
              add: permission.add || false,
              edit: permission.edit || false,
              view: permission.view || false,
              delete: permission.delete || false,
              review: permission.review || false,
            };
          });

          setSelectedPermissions(formattedPermissions);
        }

        setAdminData(data); // Assuming 'data' contains the admin details
      } catch (err) {
        setErrorMessage(err.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchAdminData();
  }, [isEditMode, id, navigate]); // Ensures the effect runs when id, edit mode, or navigation changes

  const readURL = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploading(true); // show loader

      try {
        const uploadedProfilePicture = await uploadToS3(file);

        setImagePreview(uploadedProfilePicture); // uploaded URL
        SetImagechnage(1);
      } catch (error) {
        console.error("Error uploading image:", error);
        setErrorMessage("Image upload failed");
        setTimeout(() => setErrorMessage(""), 3000);
      } finally {
        setUploading(false); // hide loader after upload
      }
    }
  };
  const allowedMimeTypes = ["image/png", "image/jpeg", "image/jpg"];
  const validateInputs = () => {
    const newErrors = {};
    if (!adminRole) newErrors.role = "Role is required";
    if (!Name) newErrors.Name = "Full name is required";
    if (!phone) newErrors.phone = "Phone is required";
    if (!email) newErrors.email = "Email is required";
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (Name) {
      if (!/^[A-Za-z\s]+$/.test(Name)) {
        newErrors.Name = "Full name must contain only alphabets";
      }
    }
    if (email) {
      if (!emailPattern.test(email)) {
        newErrors.email = "Enter a valid email address";
      }
    }
    const numericPhone = phone.replace(/\D/g, "");

    if (phone) {
      if (numericPhone.length !== 11) {
        newErrors.phone = "Enter valid phone number";
      }
    }
    if (imagechange === 1) {
      if (imagePreview) {
        try {
          // Extract file extension correctly
          const url = new URL(imagePreview);
          const pathname = url.pathname;
          const type = pathname.split(".").pop().toLowerCase(); // Ensure it's lowercase

          if (!allowedMimeTypes.includes(`image/${type}`)) {
            newErrors.profilePicture = "Only png and jpg files are allowed.";
          }
        } catch (error) {
          console.error("Invalid URL:", error);
        }
      }
    }
    if (Object.keys(newErrors).length != 0) {
      if (
        document
          .getElementById("pills-change-passwork")
          ?.classList.contains("show")
      ) {
        setErrorMessage(
          "Please fill  all information from Personal profile section"
        );
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const personalinfohandleSubmit = async (event) => {
    event.preventDefault();
    if (!validateInputs()) return;
    // setLoading(true);
    document
      .getElementById("pills-change-passwork-tab")
      ?.classList.add("active");
    document
      .getElementById("pills-change-passwork-tab")
      ?.setAttribute("aria-selected", "true");
    document
      .getElementById("pills-edit-profile-tab")
      ?.classList.remove("active");
    document
      .getElementById("pills-edit-profile-tab")
      ?.setAttribute("aria-selected", "false");
    document.getElementById("pills-change-passwork")?.classList.add("active");
    document.getElementById("pills-change-passwork")?.classList.add("show");
    document.getElementById("pills-edit-profile")?.classList.remove("active");
    document.getElementById("pills-edit-profile")?.classList.add("hide");
  };
  const handleSubmit = async (event) => {
    event.preventDefault(); // Always prevent default action first

    const permissions = Object.keys(selectedPermissions).map((moduleId) => ({
      module: moduleId,
      moduleName:
        Modulename.find((item) => item._id === moduleId)?.title || "Unknown",
      add: selectedPermissions[moduleId]?.add || false,
      edit: selectedPermissions[moduleId]?.edit || false,
      view: selectedPermissions[moduleId]?.view || false,
      delete: selectedPermissions[moduleId]?.delete || false,
      review: selectedPermissions[moduleId]?.review || false,
    }));

    // console.log(permissions);

    // Check if at least one permission is granted
    const hasValidPermission = permissions.some(
      (perm) => perm.add || perm.edit || perm.view || perm.delete || perm.review
    );

    if (!hasValidPermission) {
      setErrorMessage("Please grant permission to select any module access.");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    // Proceed with further logic if validation passes

    if (!validateInputs()) return;

    setLoading(true);

    const uploadedProfilePicture = imagePreview;
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL
      }/admin/subAdminUpdate/${id || ""}`; // Prevent undefined errors
    const authToken = localStorage.getItem("authToken");

    // Extract country code & phone number
    let phoneNumber;
    let countryCode;
    const pattern = /\(\d{3}\)/; // Checks if the number has (123) format

    if (pattern.test(phone)) {
      countryCode = phone.match(/^\+?\d+/)?.[0] || "";
    } else {
      countryCode = phone.match(/^\+?\d+/)?.[0] || "";
      const formattedNumber = phone.startsWith("+")
        ? phone.substring(countryCode.length)
        : phone;
      phoneNumber = formattedNumber.replace(
        /(\d{3})(\d{3})(\d{4})/,
        "($1) $2-$3"
      );
    }

    phoneNumber = phone.replace(/\D/g, ""); // Remove all non-numeric characters

    if (phoneNumber.startsWith("+")) {
      let countryCodeMatch = phone.match(/^\+\d+/)?.[0]; // Extracts the country code
      if (countryCodeMatch) {
        phoneNumber = phoneNumber.replace(
          countryCodeMatch.replace(/\D/g, ""),
          ""
        ); // Remove country code
      }
    } else {
      countryCode = phoneNumber.charAt(0); // First digit as country code
      phoneNumber = phoneNumber.substring(1); // Remove first digit from phone number
    }

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const payload = {
      role: adminRole,
      name: Name,
      email: email,
      profilePicture: uploadedProfilePicture,
      dialCode: countryCode, // Removed redundant '+' as countryCode includes it
      phone: phoneNumber,
      timeZone,
      permissions,
    };
    try {
      const response = await fetch(API_ENDPOINT, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage("Sub Admin has been successfully updated");
        setLoading(false);
        setTimeout(() => {
          setSuccessMessage("");
          navigate("/subadmin"); // Uncomment if needed
        }, 1000);
      } else {
        setErrorMessage(data.message);
        setTimeout(() => setErrorMessage(""), 3000);
      }
    } catch (error) {
      setErrorMessage(error.message);
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      // setLoading(false);
    }
  };

  if (loading) return <Loader />;
  return (
    <div className="row gy-4">
      <div className="col-lg-4">
        {successMessage && (
          <SuccessAlert
            message={successMessage}
            onClose={() => setSuccessMessage("")}
          />
        )}
        {errorMessage && (
          <DengerAlert
            message={errorMessage}
            onClose={() => setErrorMessage("")}
          />
        )}
      </div>
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24 active"
                  id="pills-edit-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-edit-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-edit-profile"
                  aria-selected="true"
                >
                  Personal Information
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24"
                  id="pills-change-passwork-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-change-passwork"
                  type="button"
                  role="tab"
                  aria-controls="pills-change-passwork"
                  aria-selected="false"
                  tabIndex={-1}
                >
                  Module Access
                </button>
              </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-edit-profile"
                role="tabpanel"
                aria-labelledby="pills-edit-profile-tab"
                tabIndex={0}
              >
                <h6 className="text-md text-primary-light mb-16">
                  Profile Image<span className="text-danger-600">*</span>
                </h6>
                <form action="#" onSubmit={personalinfohandleSubmit}>
                  {/* Upload Image Start */}
                  <div className="mb-24 mt-16">
                    <div className="avatar-upload">
                      <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                        <input
                          type="file"
                          id="imageUpload"
                          accept=".png, .jpg, .jpeg"
                          hidden
                          onChange={(e) => {
                            readURL(e);
                            setErrors((prev) => ({
                              ...prev,
                              profilePicture: "",
                            }));
                          }}
                        />
                        <label
                          htmlFor="imageUpload"
                          className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                        >
                          <Icon
                            icon="solar:camera-outline"
                            className="icon"
                          ></Icon>
                        </label>
                      </div>
                      <div className="avatar-preview">
                        {uploading && (
                          <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75 rounded">
                            <p>Uploading...</p>
                          </div>
                        )}
                        <div
                          id="imagePreview"
                          style={{
                            backgroundImage: `url(${imagePreview})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        />
                      </div>
                    </div>
                    {errors.profilePicture && (
                      <p className="text-danger mt-1">
                        {errors.profilePicture}
                      </p>
                    )}
                  </div>
                  {/* Upload Image End */}
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="role"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Role<span className="text-danger-600">*</span>
                        </label>
                        <select
                          id="role"
                          className={`form-select radius-8 ${errors.role ? "is-invalid" : ""
                            }`}
                          value={adminRole}
                          onChange={(e) => {
                            setAdminRole(e.target.value);
                            setErrors((prev) => ({ ...prev, role: "" }));
                          }}
                        >
                          <option value="" disabled>
                            -- Select Role --
                          </option>
                          {/* <option value="support_admin">Support Admin</option> */}
                          <option value="content_moderator">
                            Content Moderator
                          </option>
                          <option value="customer_support">
                            Customer Support
                          </option>
                        </select>
                        {errors.role && (
                          <p className="text-danger mt-1">{errors.role}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Email
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control radius-8"
                          id="email"
                          placeholder="Enter Email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setErrors((prev) => ({ ...prev, email: "" }));
                          }}
                          invalid={!!errors.email}
                          disabled
                        />
                        {errors.email && (
                          <p className="text-danger mt-1">{errors.email}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Full Name
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control radius-8 ${errors.Name ? "is-invalid" : ""
                            }`}
                          id="name"
                          placeholder="Enter Full Name"
                          value={Name}
                          onChange={(e) => {
                            setName(e.target.value);
                            setErrors((prev) => ({ ...prev, Name: "" }));
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
                              .trimStart(); // Prevent leading spaces
                          }}
                          maxLength="64"
                          invalid={!!errors.Name}
                        />
                        {errors.Name && (
                          <p className="text-danger mt-1">{errors.Name}</p>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="number"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Phone<span className="text-danger-600">*</span>
                        </label>
                        <InputMask
                          mask="+9 (999) 999 9999"
                          value={phone}
                          onChange={(e) => {
                            setPhone(e.target.value);
                            setErrors((prev) => ({ ...prev, phone: "" }));
                          }}
                          invalid={!!errors.phone}
                        >
                          {(inputProps) => (
                            <input
                              {...inputProps}
                              type="tel"
                              placeholder="Phone"
                              className={`form-control radius-8 ${errors.phone ? "is-invalid" : ""
                                }`}
                            />
                          )}
                        </InputMask>
                        {errors.phone && (
                          <p className="text-danger mt-1">{errors.phone}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className="d-flex align-items-center justify-content-center gap-3"
                    style={{
                      float: "inline-end",
                      marginTop: "10px !important",
                    }}
                  >
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                    >
                      Next
                    </button>
                  </div>
                </form>
              </div>
              <div
                className="tab-pane fade"
                id="pills-change-passwork"
                role="tabpanel"
                aria-labelledby="pills-change-passwork-tab"
                tabIndex="0"
              >
                <form action="#" onSubmit={handleSubmit}>
                  <div className="">
                    <div className="table-responsive">
                      <table className="table basic-border-table mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Module Name</th>
                            <th>Add</th>
                            <th>Edit</th>
                            <th>View</th>
                            <th>Delete</th>
                            <th>Review</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Modulename.length > 0 ? (
                            Modulename.filter(
                              (item) =>
                                item.permissions &&
                                (item.permissions.add ||
                                  item.permissions.edit ||
                                  item.permissions.view ||
                                  item.permissions.delete ||
                                  item.permissions.review)
                            ).map((item) => {
                              const validPermissions = Object.entries(
                                item.permissions
                              ).filter(([key, value]) => value);

                              return (
                                <tr key={item._id}>
                                  <td>
                                    <input
                                      className="form-check-input radius-4 border input-form-dark"
                                      type="checkbox"
                                      id={`module_${item._id}`}
                                      checked={
                                        selectedPermissions[item._id]
                                          ?.selected || false
                                      }
                                      onChange={() =>
                                        handleCheckboxChange(
                                          item._id,
                                          "selected"
                                        )
                                      }
                                    />
                                  </td>

                                  <td>
                                    {item.title === "Space Type"
                                      ? "Storage Type"
                                      : item.title === "chatpayment"
                                        ? "Chat Payment"
                                        : item.title === "transaction-promotion"
                                          ? "Promotion Payment"
                                          : item.title === "booking"
                                            ? "Booking"
                                            : item.title === "supportticket"
                                              ? "Help & Support Ticket"
                                              : item.title === "vault-questions"
                                                ? "Vault Questions"
                                                : item.title === "preferences"
                                                  ? "Preferences"
                                                  : item.title === "discovery-config"
                                                    ? "Compatibility Algorithm"
                                                      : item.title === "notification"
                                                        ? "Notification"
                                                        : item.title === "mynotification"
                                                          ? "My Notification"
                                                          : item.title === "user-report"
                                                            ? "User Report"
                                                            : item.title === "feature-requests"
                                                              ? "Feature Requests"
                                                              : item.title === "analytics-reporting"
                                                                ? "Analytics Reporting"
                                                                : item.title === "payments-transactions"
                                                                  ? "Payment and Transactions"
                                                                  : item.title === "subscriptions"
                                                                    ? "Subscriptions"
                                                                    : item.title === "help-supports"
                                                                      ? "Help And Supports"
                                                                      : item.title === "admin-settings"
                                                                        ? "Settings"
                                                                        : item.title}
                                  </td>
                                  {validPermissions.length > 0 ? (
                                    <>
                                      <td>
                                        {item.permissions.add ? (
                                          <input
                                            className="form-check-input radius-4 border input-form-dark"
                                            type="checkbox"
                                            id={`add_${item._id}`}
                                            checked={
                                              selectedPermissions[item._id]
                                                ?.add || false
                                            }
                                            onChange={() =>
                                              handleCheckboxChange(
                                                item._id,
                                                "add"
                                              )
                                            }
                                          />
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td>
                                        {item.permissions.edit ? (
                                          <input
                                            className="form-check-input radius-4 border input-form-dark"
                                            type="checkbox"
                                            id={`edit_${item._id}`}
                                            checked={
                                              selectedPermissions[item._id]
                                                ?.edit || false
                                            }
                                            onChange={() =>
                                              handleCheckboxChange(
                                                item._id,
                                                "edit"
                                              )
                                            }
                                          />
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td>
                                        {item.permissions.view ? (
                                          <input
                                            className="form-check-input radius-4 border input-form-dark"
                                            type="checkbox"
                                            id={`view_${item._id}`}
                                            checked={
                                              selectedPermissions[item._id]
                                                ?.view || false
                                            }
                                            onChange={() =>
                                              handleCheckboxChange(
                                                item._id,
                                                "view"
                                              )
                                            }
                                          />
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td>
                                        {item.permissions.delete ? (
                                          <input
                                            className="form-check-input radius-4 border input-form-dark"
                                            type="checkbox"
                                            id={`delete_${item._id}`}
                                            checked={
                                              selectedPermissions[item._id]
                                                ?.delete || false
                                            }
                                            onChange={() =>
                                              handleCheckboxChange(
                                                item._id,
                                                "delete"
                                              )
                                            }
                                          />
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td>
                                        {item.permissions.review ? (
                                          <input
                                            className="form-check-input radius-4 border input-form-dark"
                                            type="checkbox"
                                            id={`review_${item._id}`}
                                            checked={
                                              selectedPermissions[item._id]
                                                ?.review || false
                                            }
                                            onChange={() =>
                                              handleCheckboxChange(
                                                item._id,
                                                "review"
                                              )
                                            }
                                          />
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      <td>-</td>
                                      <td>-</td>
                                      <td>-</td>
                                      <td>-</td>
                                      <td>-</td>
                                    </>
                                  )}
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No Modules Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary border border-primary text-md px-5 py-3 rounded-lg mt-10"
                      disabled={loading}
                      style={{ float: "right", marginTop: "10px !important" }}
                    >
                      {loading ? "Saving..." : "Save"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSubadminPageNew;
